var React = require('react');

function ArrowRightRedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#c82122","d":"M13.783 46.887l-4.158-4.753a.594.594 0 0 0-.919 0 .82.82 0 0 0 0 1.05l3.049 3.485H.65a.749.749 0 0 0 0 1.485h11.105l-3.049 3.487a.82.82 0 0 0 0 1.05.594.594 0 0 0 .919 0l4.158-4.753a.82.82 0 0 0 0-1.051z","opacity":"0.8","transform":"translate(0 -41.916)"}));
}

ArrowRightRedInline.defaultProps = {"width":"13.973","height":"10.992","viewBox":"0 0 13.973 10.992"};

module.exports = ArrowRightRedInline;

ArrowRightRedInline.default = ArrowRightRedInline;
